module.exports = global["$"] = require("-!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?$!../~/jquery/dist/jquery.js
// module id = 44
// module chunks = 0